<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-22 09:28:43
 * @LastEditors: mrh
 * @LastEditTime: 2021-02-26 11:23:21
--> 
<template>
  <div class="searchconter">
    <div class="searchs" @click="gosearch()">
      <van-search
        v-model="searchVal"
        shape="round"
        placeholder="请输入商品名称"
        background="#fff"
        @focus="gosearch()"
      />
      <van-button type="default" icon="clear" @click="closeHandsel">退出</van-button>
    </div>
    <!-- <div class="searchs" @click="gosearch()">
      <van-search v-model="searchVal" show-action shape="round" placeholder="请输入您想购买商品名字">
        <template #action>
          <van-button color="linear-gradient(to right, #FF7D5B, #FF3636)">搜索</van-button>
        </template>
      </van-search>
    </div>-->

    <!-- <div class="side_item_head" @touchmove.stop>
      <van-tabs
        v-model="typeIndex"
        :ellipsis="false"
        type="card"
        swipe-threshold="4"
        title-active-color="#fff"
        title-inactive-color="#666"
      >
        <van-tab
          v-for="(item,index) in tabType"
          :key="index"
          :title="item.cateName"
          :name="item.cateId"
        ></van-tab>
      </van-tabs>
      <i
        class="iconfont icon-home_location_icon_d"
        style="margin-left:auto"
        @click="showType = !showType"
      ></i>

      <van-popup v-model="showType">
        <p>
          <span>全部分类</span>
          <i class="iconfont icon-home_location_icon_u" @click="showType = !showType"></i>
        </p>
        <div class="pupList">
          <span v-for="(item,idx) in tabType" :key="idx">{{item.cateName}}</span>
        </div>
      </van-popup>
    </div>-->

    <div v-if="showSideBar">
      <side-bar-list :list-datas="listdata">
        <!-- <slot name="slotVal"></slot> -->
        <!-- <template v-slot:countDowm="item">
          <van-count-down :time="item.countDown" format="DD天HH:mm:ss结束" />
        </template>
        <template v-slot:slotVal>
          <span>分享好友购买，0元获得同款商品</span>
        </template>-->
      </side-bar-list>
    </div>
  </div>
</template>
<script>
import { supplyOfGoods, supplyOfGoodsCate } from "@/api/join";
import sideBarList from "@/components/sideBarList/sideBarList";
export default {
  components: {
    sideBarList
  },
  data() {
    return {
      // headerMsg: {},
      searchVal: "",
      typeIndex: 0,
      showType: false,
      list: [{ cateList: [], list: [] }],
      listdata: [{ cateList: [], list: [] }],
      showSideBar: false
    };
  },
  mounted() {
    // this.supplyOfGoods();
    this.supplyOfGoodsCate();
  },
  methods: {
    supplyOfGoodsCate() {
      let obj = {
        communityShopId: this.$store.getters.communityShopId, //社区店长id
        type: "2" //表示从首页获取分类,2表示从我的店铺里面查找货源
      };
      supplyOfGoodsCate(obj).then(res => {
        this.list[0].cateList = res.content.cateList;
        this.supplyOfGoods(res.content.cateList[0].cateId);
        this.showSideBar = true;
        // console.log(this.list[0].cateList);
      });
    },
    supplyOfGoods(id) {
      let obj = {
        cateId: id, //2级分类id（商品分类的2级）
        csId: this.$store.getters.communityShopId, //社区店长id
        type:'1'
      };
      supplyOfGoods(obj).then(res => {
        // console.log(res)
        this.list[0].list = res.content.cateList;
        this.listdata = this.list;
      });
    },
    gosearch() {
      this.$router.push("/searchGoods");
    },
    showPopups(bol) {
      // console.log(bol)
      this.showPopup = bol;
    },
    closeHandsel() {
      // url有值时路由跳转
      if (this.$route.meta.headerBack) {
        if (this.$store.getters.ambientType == 1) {
          window.Android.closeHandsel();
        } else if (this.$store.getters.ambientType == 2) {
          window.webkit.messageHandlers.closeHandsel.postMessage("");
        }
        return;
      }
      this.$router.go(-1);
    }
  },
  computed: {
    // name() {
    //   // 返回视频名称
    //   return this.videoList.length > 0 ? this.videoList[0].cfpName : "";
    // }
  },
  watch: {
    "$store.getters.isRecommend": {
      handler(newV, oldV) {
        // console.log(newV);
        if (newV) {
          // console.log(this.$store.getters.cateId, "2");
          this.supplyOfGoods(this.$store.getters.cateId);
        }
        setTimeout(() => {
          this.$store.commit("user/SET_recommend", true)
          this.$store.commit("user/SET_isRecommend", false);
        }, 200);
      },
      // immediate: true,
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.searchconter {
  width: 100%;
  height: calc(100% - 50px);
  overflow: hidden;
  // background: #f4f4f4;
  .searchs {
    width: 100%;
    height: 44px;
    position: fixed;
    z-index: 99;
    display: flex;
    align-items: center;
    z-index: 99;
    .van-search {
      padding: 2px 0;
      // position: fixed;
      width: 293px;
      z-index: 99;
      margin-left: 10px;
      .van-cell {
        padding: 4px;
      }
    }
    .van-button {
      width: 49px;
      height: 25px;
      padding: 0;
      border-radius: 16px;
      position: absolute;
      right: 15px;
      z-index: 88;
      i {
        color: #999;
        font-size: 16px;
      }
      .van-button__text {
        font-size: 12px;
        margin-left: 2px;
      }
    }
  }
  /deep/.side_item_head {
    width: -webkit-fill-available;
    height: 40px;
    padding: 0 8px 0 0px;
    // margin-top: 50px;
    display: flex;
    align-items: center;
    position: fixed;
    top: 49px;
    z-index: 99;
    background: #fff;
    overflow-y: hidden;
    .van-tabs {
      width: 268px;
      height: 27px;
      line-height: 27px;
      padding: 0;
      border-radius: 4px;
      .van-tab {
        width: auto;
        height: 15px;
        line-height: 21px;
        flex: none;
        margin: 0 4px;
        padding: 5px 12px;
        border-radius: 4px;
        background: #F8F8F8;
        box-sizing: content-box;
        // text-overflow: ellipsis;
        // overflow: hidden;
        border-radius: 13px;
        border:1.04px solid #E2E2E2;
        .van-tab__text {
          font-size: 12px;
          font-weight: bold;
          color: #333;
          // text-overflow: ellipsis;
          // overflow: hidden;
          // white-space: nowrap;
        }
      }
      .van-tab--active {
        background: #FDF6EC;
        border-color: #FF9900;
        .van-tab__text {
          color: #FF9900;
          
        }
      }
      .van-tabs__line {
        height: 0;
      }
      [class*="van-hairline"]::after {
        border: none;
      }
    }
    .van-popup--center {
      width: 100%;
      height: 250px;
      top: 220px;
      // left: 0;
      > p {
        width: auto;
        height: 50px;
        padding: 0 8px 0 15px;
        display: flex;
        align-items: center;
        span {
          color: #1d1d1d;
          font-size: 15px;
          margin-right: auto;
        }
      }
    }
    .van-overlay {
      top: 345px;
    }
  }
}
</style>

